import { useSelector } from 'react-redux';
import { useRouteProps } from 'src/common/providers/RoutePropsProvider';
import { getSelectCategory } from '../selectors/categories';
import { getSelectProfile } from '../selectors/profiles';

export default function useRouteGuideItem() {
  const guideId = useRouteProps().guideContext.guideId;
  const categoryGuideItem = useSelector(getSelectCategory(guideId));
  const profileGuideItem = useSelector(getSelectProfile(guideId));

  return categoryGuideItem || profileGuideItem;
}
